<template>
  <div style="text-align: center; width: 100%">
    <van-loading type="spinner" size="60px" />
  </div>
</template>
<script>
/* eslint-disable no-undef,no-unused-vars */
import trackerApi from '@/api/trackerApi';
import config from '@/config';
import { createTracker } from 'sf-tracker';
import router from '@/router/index';
export default {
  name: 'raxwLogin',
  data() {
    return {
      user: null,
      raxwUser: null
    };
  },
  created() {
    if (process.env.NODE_ENV === 'production') {
      this.proLogin();
    } else if (process.env.NODE_ENV === 'development') {
      this.proLogin();
    }
  },
  mounted() {},
  methods: {
    proLogin() {
      let that = this;
      CP.isLogin({
        completed: function (data) {
          console.log('isLogin', data);
          if (data.is_login === 1) {
            // 已登录， 获取用户信息
            CP.getCustomerInfo({
              completed: function (data) {
                console.log('getCustomerInfo', data);
                // 1. 成功获取用户信息 保存vuex
                that.$store.commit('SET_RAXW_USER', data);
                that.$store.commit('SET_ENV', 'raxw');
                // 2. 调用接口获取userCode
                let formData = {
                  appId: config.TRACKER.APP_ID,
                  accountId: data.account_id,
                  platform: 'tmy',
                  phone: data.mobile,
                  name: data.nick_name
                };
                console.log(formData);
                trackerApi.initUser(formData).then((res) => {
                  if (res.code === 200) {
                    let userCode = res.msg;
                    console.log('tracker userCode:' + userCode);
                    console.log('createTracker');
                    // 3. 初始化sf-tracker
                    // createTracker({
                    //   appId: config.TRACKER.APP_ID,
                    //   userId: userCode,
                    //   singleton: false,
                    //   vueRouter: {
                    //     router
                    //   }
                    // });
                    createTracker({
                      appId: config.TRACKER.APP_ID,
                      userId: userCode,
                      url: 'http://event.tracking.raqq.cn/eventTracking',
                      singleton: false,
                      heartBeat: 10000,
                      vueRouter: {
                        router
                      },
                      CP: window.CP
                    });
                    // 4. 跳转至登录页
                    that.$router.replace('/index');
                  } else {
                    that.$router.replace('/index');
                  }
                });
              },
              cpIncompatible: function () {
                console.log('此环境不支持此方法');
              }
            });
          } else {
            // 未登录， 提示用户登录
            CP.showLogin({
              completed: function (data) {
                window.location.reload();
                CP.tools.writelog('show_login', data);
              },
              cpIncompatible: function () {
                CP.tools.writelog('', '此环境不支持此方法');
              }
            });
          }
        },
        cpIncompatible: function () {
          console.log('此环境不支持此方法');
        }
      });
    },
    async initUser(data) {
      return trackerApi.initUser(data);
    },
    devLogin() {
      let userCode = this.initUser().msg;
      console.log(userCode);
      this.$store.commit('SET_RAXW_USER', {
        score: 7711,
        ref_user_code: '1023',
        account_id: '62047dfb010ef63b9dfc760c',
        invitation_number: 5,
        head_img: 'https://img.tmuyun.com/assets/20230705/1688527387503_64a4e21b79f6be61f9bf56ca.png',
        nick_name: '葡萄战车raxw版本',
        mobile: '18815158532',
        ref_user_uid: '12173',
        ref_code: 'XUX4D9',
        username: '葡萄战车raxw版本'
      });
      this.$store.commit('SET_ENV', 'raxw');
      this.$router.replace('/index');
    }
  }
};
</script>

<style lang="less" scoped></style>
